<div class="main-page-section default_font py-3 py-md-4 px-3 px-md-4 px-lg-5 d -flex flex-column">
    <div class="flex-fill border-bottom boder-light mb-4 mb-md-5">
        <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
            <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/list-survey">List Polls / Survey</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev">Survey Response Summary</span>
        </div>

        <div class="align-items-center justify-content-between mb-3 mb-md-4">
            <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
                <h2 class="font-weight-bold mb-3 mb-md-4">Survey Response Summary</h2>
                <button class="btn btn-primary" (click)="openModalRemoveSurvey()" *ngIf="surveyRemove">Remove</button>
            </div>
            <h4 class="text-primary font-weight-semibold">Survey Name: {{surveyDetails?.data.surveyName}}</h4>
        </div>

        <h6 class="font-weight-light h5 mb-3 mb-md-4">Survey Attributes</h6>
        <div class="row row-gap-4 mb-4 mb-md-5">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Park Name</small>
                <span class="font-weight-medium text-gray-dark">{{surveyDetails?.data.parkName}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Survey Start Date</small>
                <span
                    class="font-weight-medium text-gray-dark">{{formatDateAll(surveyDetails?.data.surveyStartDate,'date')}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">SurveyEnd Date</small>
                <span
                    class="font-weight-medium text-gray-dark">{{formatDateAll(surveyDetails?.data.surveyEndDate,'date')}}</span>
            </div>
            <!-- <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Coupon Assinged</small>
                <span class="font-weight-medium text-gray-dark">{{surveyDetails?.data.couponTitle}}</span>
            </div> -->
        </div>
    </div>

    <div class="row mb-4 mb-md-5">
        <div class="col-12 col-lg-8 col-xl-6">
            <h6 class="font-weight-light h5 mb-3 mb-md-4">Survey Answer Statistics</h6>
            <div class="form-group floating_form_field mb-0 w-100">
                <select class="form-control" name="questionId" (change)="getQuestionId($event)"
                    [(ngModel)]="pollsandsurvey.questionId">
                    <!-- <option value="">Select Survey Answer Statistics</option> -->
                    <option value="{{surveyanswer.questionId}}" *ngFor="let surveyanswer of surveyStatisticsList">
                        {{surveyanswer.questionName}}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div ngbNav #nav="ngbNav" class="custom_tab" [destroyOnHide]="false">
        <div ngbNavItem>
            <a ngbNavLink>
                <svg-icon src="/assets/images/icons/bar_graph.svg"></svg-icon>
                Bar Graph
            </a>
            <ng-template ngbNavContent>
                <canvas id="canvasbar" [height]="500" [width]="900"></canvas>
            </ng-template>
        </div>
        <div ngbNavItem>
            <a ngbNavLink>
                <svg-icon src="/assets/images/icons/pie_chart.svg"></svg-icon>
                Pie Chart
            </a>
            <ng-template ngbNavContent>
                <canvas id="canvaspie" [width]="380" [height]="380"></canvas>
            </ng-template>
        </div>
    </div>
    <div [ngbNavOutlet]="nav" class="pt-3 pt-md-4 mb-5"></div>

    <div class="row">
        <div class="col-12 col-lg-10 col-xl-8">
            <div class="survey_response_card shadow-lg p-3 py-md-4">
                <div class="row row-gap-2">
                    <div class="col-12 col-md-2 text-center align-self-center">
                        <h3 class="h6 font-weight-semibold mb-0">Response <br>Overview</h3>
                    </div>
                    <div class="col-12 col-md-1">
                        <span class="_card_separator"></span>
                    </div>
                    <div class="col-12 col-md-5">
                        <div class="form-row mb-2 mb-md-3">
                            <div class="col-12 col-md-4 d-flex flex-column">
                                <h4 class="h6 font-weight-semibold mb-0 flex-fill">Total <br>Members</h4>
                                <span
                                    class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{totalMemberCount}}</span>
                            </div>
                            <div class="col-12 col-md-4 d-flex flex-column">
                                <h4 class="h6 font-weight-semibold mb-0 flex-fill">Members <br>Responded</h4>
                                <span
                                    class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{respondedMemberCount}}</span>
                            </div>
                            <div class="col-12 col-md-4 d-flex flex-column">
                                <h4 class="h6 font-weight-semibold mb-0 flex-fill">Response on <br>Short Answers</h4>
                                <span
                                    class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{shortAnswerMemberResponseCount}}</span>
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary" (click)="openModal(surveyId)"
                            *ngIf="surveyCreate">Send Reminder to Non
                            Responders</button>
                    </div>
                    <div class="col-12 col-md-1">
                        <span class="_card_separator"></span>
                    </div>
                    <div class="col-12 col-md-3 text-center align-self-center">
                        <!-- <button type="button" class="btn btn-cyan text-white"
                            (click)="downloadReport(surveyId)">Download Report</button> -->
                        <a class="btn btn-cyan text-white" [attr.href]="baseUrl" download>Download Report</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>